import { Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { IPageDataV2, IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { Status } from '@df/core/status';
import { ICmsPageResource } from '@icms/core/resource/page/icms-page.resource';
import find from 'lodash-es/find';
import get from 'lodash-es/get';
import orderBy from 'lodash-es/orderBy';
import { ICmsPageDecorator } from '../../page/icms-page.decorator';
import { CMS_BLOG_GROUP_NAVIGATION_CONFIG } from './cms-blog-group-navigation.config';
import { NCmsBlogGroup } from './cms-blog-group-navigation.interface';

@Injectable({
    providedIn: 'root'
})
export class CmsBlogGroupNavigationService {
    constructor(
        protected requestService: RequestService,
        protected pageResource: ICmsPageResource
    ) {}

    /**
     * Get page by created-at date navigation (next, prev)
     */
    loadPageCreatedNav(
        status: Status | undefined,
        model: ICmsPageDecorator<IPageDataV3>,
        cb?: (pageNav: NCmsBlogGroup.INavigation) => void
    ): void {
        const parent = model.data?.parent;

        if (parent) {
            this.loadSiblingPages(status, model, (pages: ICmsPageDecorator<IPageDataV2>[]) => {
                if (cb) {
                    const sortedPages = this.sortPagesByDate(pages);
                    const pageIndex = sortedPages.indexOf(model);
                    const prev = sortedPages[pageIndex - 1];
                    const next = sortedPages[pageIndex + 1];
                    cb({ prev, next });
                }
            });
        } else if (cb) {
            cb({ prev: undefined, next: undefined });
        }
    }

    private sortPagesByDate(pages: ICmsPageDecorator<IPageDataV2>[]): ICmsPageDecorator<IPageDataV2>[] {
        const sortedPages = orderBy(
            pages.filter(i => !!i.data),
            CMS_BLOG_GROUP_NAVIGATION_CONFIG.getSiblingsSortedByDateIterates,
            CMS_BLOG_GROUP_NAVIGATION_CONFIG.getSiblingsSortedByDateOrders
        ) as ICmsPageDecorator<IPageDataV3>[];

        return sortedPages.sort((a, b) => {
            const sortValueA = find(CMS_BLOG_GROUP_NAVIGATION_CONFIG.getSiblingsSortedByDateIterates, iteratee => get(a, iteratee));
            const sortValueB = find(CMS_BLOG_GROUP_NAVIGATION_CONFIG.getSiblingsSortedByDateIterates, iteratee => get(b, iteratee));

            if (sortValueA && sortValueB) {
                return 0;
            } else if (sortValueA) {
                return -1;
            } else {
                return 1;
            }
        });
    }

    /**
     * Loads all pages from given group ids
     */
    private loadSiblingPages(
        status: Status | undefined,
        model: ICmsPageDecorator<IPageDataV3>,
        onSuccess?: (pages: ICmsPageDecorator<IPageDataV2>[]) => void
    ) {
        const parent = model.data?.parent;
        const pageType = model.data?.pageType;

        this.requestService.send(
            status,
            () => {
                return this.pageResource.find({
                    verbosity: 2,
                    filter: { parent, pageType }
                });
            },
            onSuccess
        );
    }
}
